import React from 'react';

import PropTypes from 'prop-types';

import ContentLoader from '@adsk/alloy-react-content-loader';

const widths = [113, 53, 88, 60, 130, 61, 124, 112, 124, 118];

type Item = {
  collapsed?: boolean;
  index: number;
};

const SideNavigationItemLoader = ({ collapsed, index, ...props }: Item) => (
  <ContentLoader width={collapsed ? 24 : 196} height={24} {...props}>
    {!collapsed && (
      <rect
        x="36"
        y="8"
        rx="4"
        ry="4"
        width={widths[index % widths.length]}
        height="8"
      />
    )}
    <rect x="0" y="0" rx="12" ry="12" width="24" height="24" />
  </ContentLoader>
);

SideNavigationItemLoader.displayName = 'SideNavigationItemLoader';

SideNavigationItemLoader.propTypes = {
  collapsed: PropTypes.bool,
  /** The index of the loader, used to decide the width */
  index: PropTypes.number.isRequired,
};

export default SideNavigationItemLoader;
